export default __webpack_public_path__ + "static/media/Clan Bound Harness of the Four Winds.0040d5fb.jpg";